import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailFileSummaryComponent } from './detail-file-summary.component';

@NgModule({
  declarations: [DetailFileSummaryComponent],
  imports: [CommonModule, MaterialModule, TablerIconsModule, SharedModule],
  exports: [DetailFileSummaryComponent]
})
export class DetailFileSummaryModule {}
